import { Injectable } from '@angular/core';
import { SummaryComponent } from '@shared/.';
import { MenuItem } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class SummaryPresenter {
  view!: SummaryComponent;

  setView(view: SummaryComponent): void {
    this.view = view;
  }

  getGroups(): string {
    let groups: MenuItem[] | null = null;
    this.view.groupList$
      .pipe(
      ).subscribe((items) => {
        groups = items
      }
    )
    return (groups ?? []).map((item: MenuItem)=>item['name']).join(', ')
  }

  getSubgroups(): string {
    let groups: MenuItem[] | null = null;
    this.view.subgroupList$
      .pipe(
      ).subscribe((items) => {
        groups = items
      }
    )
    return (groups ?? []).map((item: MenuItem)=>item['name']).join(', ')
  }

  getStores(): string {
    let groups: MenuItem[] | null = null;
    this.view.storeList$
      .pipe(
      ).subscribe((items) => {
        groups = items
      }
    )
    return (groups ?? []).map((item: MenuItem)=>item['name']).join(', ')
  }    
}
